/* Navigation */

const headerNavigation = document.getElementById("header-navigation");
const headerNavigationOffset = headerNavigation.offsetTop;

headerNavigation.style.maxHeight = window.innerHeight + "px";

window.onscroll = function () {
	fixedNav();
};

const fixedNav = () => {
	const rect = headerNavigation.getBoundingClientRect();

	if (rect.top <= 0 && !headerNavigation.classList.contains("fixed-nav")) {
		headerNavigation.classList.add("fixed-nav");
	}

	if (scrollY < 160 && headerNavigation.classList.contains("fixed-nav")) {
		headerNavigation.classList.remove("fixed-nav");
	}
};

let menuButtonActive = false;
const menuButton = document.getElementById("menu-button");
const navMobile = document.getElementById("mobile-nav");
const headerNav = document.getElementById("header-navigation");

document.getElementById("menu-button").onclick = function () {
	toggleMenu();
};

function toggleMenu() {
	if (menuButtonActive) {
		menuButton.classList.remove("is-active");
		navMobile.style.transition = "ease-in-out .5s";
		closeNav();
	} else {
		menuButton.classList.add("is-active");
		openNav();
	}
}

function openNav() {
	navMobile.style.height = navMobile.scrollHeight + "px";
	menuButtonActive = true;
	navMobile.style.transition = "ease-in-out .5s";
	headerNav.style.position = "absolute";
	headerNav.style.top = "0px";
	headerNav.style.overflow = "scroll";
}

function closeNav() {
	navMobile.style.height = "0px";
	menuButtonActive = false;
	headerNav.style.overflow = "visible";
}

function removeScroll() {
	document.body.style.position = "fixed";
	document.body.style.top = `-${window.scrollY}px`;
}

function enableScroll() {
	const scrollY = document.body.style.top;
	document.body.style.position = "";
	document.body.style.top = "";
	window.scrollTo(0, parseInt(scrollY || "0") * -1);
}

document.addEventListener("keyup", keyUpHandler);

function keyUpHandler(event) {
	if (event.which === 27) {
		closeNav();
		headerNav.style.position = "inherit";
	}
}

window.addEventListener(
	"resize",
	function (event) {
		if (window.innerWidth > 1000) {
			navMobile.style.transition = "ease-in-out 0s";
			headerNav.style.position = "inherit";
			headerNav.style.top = "10px";
			closeNav();
		}
	},
	true
);

const hasChild = document.getElementsByClassName("has-child");

for (let i = 0; i < hasChild.length; i++) {
	hasChild[i].addEventListener("click", function () {
		let theChild = this.lastElementChild;
		if (this.classList.contains("open") && window.innerWidth < 1000) {
			this.classList.remove("open");
			navMobile.style.height = navMobile.scrollHeight - theChild.scrollHeight + "px";
			navMobile.style.transition = ".2s";
			theChild.style.height = "0";
		} else if (window.innerWidth < 1000) {
			this.classList.add("open");
			navMobile.style.transition = ".2s";
			theChild.style.height = theChild.scrollHeight + "px";
			navMobile.style.height = navMobile.scrollHeight + theChild.scrollHeight + "px";
		} else {
			return;
		}
	});
}

/* FAQ */

const question = document.getElementsByClassName("question");

for (let i = 0; i < question.length; i++) {
	question[i].addEventListener("click", function () {
		this.classList.toggle("active");

		let answer = this.nextElementSibling;
		if (answer.style.maxHeight) {
			answer.style.maxHeight = null;
		} else {
			answer.style.maxHeight = answer.scrollHeight + "px";
		}
	});
}

/* Melano Product Page */

document.addEventListener("DOMContentLoaded", function () {
	var secondarySlider = new Splide("#secondary-slider", {
		fixedWidth: 111,
		height: 111,
		gap: 10,
		cover: true,
		arrows: false,
		pagination: false,
		isNavigation: true,
		focus: "left",
		breakpoints: {
			900: {
				fixedWidth: 100,
				height: 100,
			},
			600: {
				fixedWidth: 88,
				height: 88,
			},
		},
	}).mount();

	var primarySlider = new Splide("#primary-slider", {
		type: "fade",
		heightRatio: 1,
		pagination: false,
		arrows: false,
		cover: true,
	});

	primarySlider.sync(secondarySlider).mount();
});

/* First slider or banner */

let mainContent = document.getElementById("MainContent");
let firstChild = mainContent.firstElementChild;

function fadeIn() {
	if (
		firstChild.classList.contains("image-banner-slider-section") ||
		firstChild.classList.contains("image-banner-ii-section") ||
		firstChild.classList.contains("video-banner-section")
	) {
		firstChild.classList.add("fade-in");
	} else {
		return;
	}
}

fadeIn();

/* Hide Sign-Up in Footer on Dealer Page */

const dealerPageIntro = document.getElementById("dealer-page");
const footerSignUp = document.getElementById("footer-sign-up");

function hasDealerPage() {
	if (dealerPageIntro) {
		footerSignUp.classList.add("hidden");
	} else {
		footerSignUp.classList.remove("hidden");
		return;
	}
}

document.addEventListener("DOMContentLoaded", hasDealerPage());
